import { DtoIndividualReportDataResponse } from "@/types";
import {
  SolutionJourney,
  SolutionJourneyItem,
  useSolutionJourney,
} from "../../FuturebilityCockpit/hooks/useSolutionCategoryPageData";
import { getAnswerFromEntries } from "./useReflectionIndividualData";

export interface SolutionIndividualDataResponse {
  commonJourneyData: SolutionJourney[];
  dynamicJourneyData: DynamicJourneyDataItem[];
}

export interface SolutionIndividualDataArgs {
  rawData?: DtoIndividualReportDataResponse;
  sessionId: string;
}

export interface DynamicJourneyDataItem extends SolutionJourneyItem {
  journeyTitle: string;
  journeyId: string;
  journeyColor: string;
  question: {
    id?: string;
    text?: string;
    dbColumn?: string;
    answer?: string;
  };
}

export function useSolutionIndividualData({
  rawData,
}: SolutionIndividualDataArgs): SolutionIndividualDataResponse {
  const currentTestId = rawData!.tests[0]._id;
  const solutionTestSet = rawData!.solutionTestSets[0];
  const allEntries = rawData!.allEntries;

  const commonJourneyData = useSolutionJourney({
    testSets: rawData!.solutionTestSets,
    currentTestId,
  });

  return {
    commonJourneyData,
    dynamicJourneyData: commonJourneyData.reduce((acc, journey) => {
      const currentJourneyItems = journey.items.map(journeyItem => {
        const journeyItemQuestion = solutionTestSet.items.find(
          q => q._id === journeyItem.id
        );
        return {
          journeyTitle: journey.title,
          journeyId: journey.id,
          journeyColor: journey.color,
          question: {
            id: journeyItemQuestion?._id,
            text: journeyItemQuestion?.text,
            dbColumn: journeyItemQuestion?.dbColumn,
            answer: getAnswerFromEntries(
              allEntries,
              solutionTestSet._id,
              journeyItemQuestion?.dbColumn || ""
            ),
          },
          ...journeyItem,
        };
      });
      return [...acc, ...currentJourneyItems];
    }, [] as DynamicJourneyDataItem[]),
  };
}
